import React from "react"
import {
	Paper,
	Grow,
	Box,
	Icon,
	Typography,
	makeStyles,
	Grid,
} from "@material-ui/core/"
import { useTranslation } from "react-i18next"
import CalcCard from "../components/CalcCard"
import { ReactComponent as Airplane } from "../img/airplane.svg"
import { ReactComponent as Car } from "../img/car.svg"
import { ReactComponent as PublicTransport } from "../img/public-transport.svg"
import { ReactComponent as Footprint } from "../img/footprint.svg"
const useStyles = makeStyles((theme) => ({}))

const CallToAction = ({ title, content, category }) => {
	const classes = useStyles()
	const { t } = useTranslation()
	const ctaTranslations = {
		title: "cta." + category + ".title",
		content: "cta." + category + ".content",
		urls: {
			flights: "/calculate-your-flights",
			footprint: "/footprint-calculator",
			car: "/calculate-your-car",
			publictransport: "/calculate-your-public-transport",
		},
		icons: {
			flights: <Airplane />,
			publictransport: <PublicTransport />,
			car: <Car />,
			footprint: <Footprint />,
		},
	}
	return (
		<Grid
			container
			direction="row"
			justify="center"
			alignItems="stretch"
			spacing={1}
		>
			<Grid item xs={12} sm={10}>
				<Typography align="center" variant="h3">
					{title}
				</Typography>
				<Box className="typodivider" />
				<Typography align="center" variant="body1">
					{content}
				</Typography>
			</Grid>
			<Grid item xs={12}>
				<CalcCard
					title={t(ctaTranslations.title)}
					icon={ctaTranslations.icons[category]}
					content={t(ctaTranslations.content)}
					url={t(ctaTranslations.urls[category])}
				/>
			</Grid>
		</Grid>
	)
}

export default CallToAction
